module.exports = __webpack_public_path__ + "img/2026big8.5e8cee9c.png";